import { render, staticRenderFns } from "./IonlineSimManagement.vue?vue&type=template&id=5229cb5e&scoped=true&"
import script from "./IonlineSimManagement.vue?vue&type=script&lang=js&"
export * from "./IonlineSimManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5229cb5e",
  null
  
)

export default component.exports